export default __webpack_public_path__ + "static/media/linked_in.2c5abb80.svg";